import { render, staticRenderFns } from "./MyAgree.vue?vue&type=template&id=2ca176cc"
import script from "./MyAgree.vue?vue&type=script&lang=js"
export * from "./MyAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports